<template>
  <div>
    <v-container>
        <h3 class="text-xs-center">Tracker</h3>
        <h4 class="text-xs-center" v-if="user">{{user.name}}</h4>
          <v-layout style="margin-top:25px;">
            <v-flex xs6 class="text-xs-center">
                <h5>Latitude</h5>
                <h6>{{position.lat}}</h6>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
                <h5>Longitude</h5>
                <h6>{{position.lng}}</h6><p></p>
            </v-flex>
          </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'car',
  data() {
      return {
          position: {
              lat: 0,
              lng: 0
          },
          timestamp: null,
      }
  },
  computed: {
    user () {
        return this.$store.getters.user;
    }
  },
  mounted() {
      this.$store.dispatch('init');

      if(navigator.geolocation) {
          navigator.geolocation.watchPosition((pos) => {
              this.position.lat = pos.coords.latitude;
              this.position.lng = pos.coords.longitude;
              this.timestamp = pos.timestamp;

              if(this.user) {
                  this.$store.dispatch('ADD_CAR_LOCATION', {
                      email: this.user.email,
                      name: this.user.name,
                      lat: this.position.lat,
                      lng: this.position.lng,
                      time: this.timestamp
                  });
              }
          });
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Car.vue